export enum EpsEndpoints {
    GetContractor = "insureds/:userIdentity/insurances/eps/plans/:planNumber/contractors/:contractorId",
    GetHolder = "insureds/:userIdentity/insurances/eps/plans/all/insureds?insured-code=:insuredCode",
}
